import type { SVGProps } from 'react';

const MobileLoadingHeroInputs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={190}
    viewBox="0 0 375 190"
    width={375}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <clipPath id="a">
      <path d="m0 0h375v189.5h-375z" />
    </clipPath>
    <g clipPath="url(#a)" opacity={0.5}>
      <path
        d="m202.5 181c30.652 0 55.5-24.848 55.5-55.5 0-30.6518-24.848-55.5-55.5-55.5s-55.5 24.8482-55.5 55.5c0 30.652 24.848 55.5 55.5 55.5z"
        fill="#fd6a46"
      />
      <path d="m0 61 76 25 101 103h-177z" fill="#87bf40" />
      <path
        d="m147.555 161.943c32.681-30.632 122.245-101.372 227.445-73.617v97.674h-142s-94.283-15.774-85.445-24.057z"
        fill="#264a29"
      />
      <path
        d="m0 76.3s37.5-4.7001 72 31.3c34.5 36 70.5 74.078 98.5 81.9h204.5v-38.082s-28-15.129-72 16.172-109 1.043-128.5-16.172-58-67.818-80.5-95.988-59.5-55.42902344-94-55.42902344z"
        fill="#36763b"
      />
      <path d="m0 126.716s106.684-17.926 183 62.091h-183z" fill="#a0c76f" />
    </g>
  </svg>
);
export default MobileLoadingHeroInputs;
